import React from 'react'
import { Outlet, NavLink, useLocation } from 'react-router-dom'
import '../../styles/pages.css'

const tabs = [
  { path: '/orders/list', label: 'Orders' },
  { path: '/orders/cases', label: 'Cases' },
  { path: '/orders/returns', label: 'Return Items' }
]

function OrdersPage() {
  const location = useLocation()

  return (
    <div className="page">
      <div className="pageHead">
        <h1>Orders</h1>
        <p>Search and manage Shopify orders</p>
      </div>

      <div className="pageTabs">
        {tabs.map(tab => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={location.pathname === tab.path ? 'active' : ''}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  )
}

export default OrdersPage
